import { render, staticRenderFns } from "./r-boat-config-dialog.vue?vue&type=template&id=54a61c58&scoped=true"
import script from "./r-boat-config-dialog.vue?vue&type=script&lang=js"
export * from "./r-boat-config-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-boat-config-dialog.vue?vue&type=style&index=0&id=54a61c58&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a61c58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a61c58')) {
      api.createRecord('54a61c58', component.options)
    } else {
      api.reload('54a61c58', component.options)
    }
    module.hot.accept("./r-boat-config-dialog.vue?vue&type=template&id=54a61c58&scoped=true", function () {
      api.rerender('54a61c58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/boats/r-boat-config-dialog.vue"
export default component.exports